<template lang="pug">
  v-row.fill-height
    v-col(xl=10 cols=12).fill-column
      div(v-if="instructionTypes.html === currentItem.type")
        p(v-html="currentItem.content")

      .fill-height(
        v-if="instructionTypes.video_resource === currentItem.type"
      )
        iframe(
          :src="getEmbedUrl(currentItem.url)"
          frameborder="0"
          :allow="videoAllows"
          :style="videoCssStyles"
        )
</template>

<script>
import Constants from '../constants';

export default {
  props: {
    currentItem: { type: Object, required: true },
  },
  data() {
    return {
      instructionTypes: Constants.INSTRUCTIONS_TYPES,
      videoCssStyles: {
        height: '500px',
        width: '100%',
        'min-height': '360px',
      },
      videoAllows: [
        'accelerometer',
        'autoplay',
        'clipboard-write',
        'encrypted-media',
        'gyroscope',
      ].join(';'),
    };
  },
  methods: {
    getEmbedUrl(url) {
      const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
      const match = url.match(regExp);

      const result = match.slice(2).join('');
      // console.log(`https://www.youtube.com/embed/${result}`);
      if (result) return `https://www.youtube.com/embed/${result}`;
      return '';
    },
  },
};
</script>
